import { useState } from "react";
import { Box } from "@mui/material";
import BoardColumn from "./BoardColumn";
import InitiativeDialog from "./InitiativeDialog";
import useInitiativeSelection from "../hooks/useInitiativeSelection";
import { useLookups } from "../hooks/useLookups";

export default function BoardView({ initiatives, mutations, onInitiativeChange }) {
  const { horizons } = useLookups();
  const horizonNames = horizons.map((h) => h.name);
  const canDrag = Boolean(onInitiativeChange);
  const selection = useInitiativeSelection(mutations);
  const [dragOverHorizon, setDragOverHorizon] = useState(null);

  const handleDragOver = (event, horizon) => {
    event.preventDefault();
    setDragOverHorizon(horizon);
  };

  const handleDragLeave = (horizon) => {
    setDragOverHorizon((prev) => (prev === horizon ? null : prev));
  };

  const handleDrop = (event, horizon) => {
    event.preventDefault();
    setDragOverHorizon(null);
    const id = event.dataTransfer.getData("text/plain");
    if (!id) return;
    const initiative = initiatives.find((i) => String(i.id) === id);
    if (initiative && initiative.horizon !== horizon) {
      onInitiativeChange?.(id, { horizon });
    }
  };

  const styles = {
    root: { p: 3 },
    board: {
      display: "flex",
      gap: 2,
      alignItems: "flex-start",
      overflowX: "auto",
    },
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.board}>
        {horizonNames.map((horizon) => (
          <BoardColumn
            key={horizon}
            horizon={horizon}
            initiatives={initiatives.filter((i) => i.horizon === horizon)}
            isDragOver={dragOverHorizon === horizon}
            onDragOver={(event) => handleDragOver(event, horizon)}
            onDragLeave={() => handleDragLeave(horizon)}
            onDrop={(event) => handleDrop(event, horizon)}
            onCardClick={selection.select}
            canDrag={canDrag}
          />
        ))}
      </Box>
      <InitiativeDialog selection={selection} />
    </Box>
  );
}
